module.exports = __webpack_public_path__ + "static/favicon-2a74affd3e7bd7687b1ce01f5a3d5324.svg";